import { render, staticRenderFns } from "./DoubleTextFieldComponent.vue?vue&type=template&id=43060a38&"
import script from "./DoubleTextFieldComponent.vue?vue&type=script&lang=js&"
export * from "./DoubleTextFieldComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports